import React from 'react';
import { Skeleton } from 'antd';
import { SkeletonCard } from './styles';

const MetricCardSkeleton: React.FC = () => {
  return (
    <SkeletonCard>
      <Skeleton active paragraph={{ rows: 2 }} title={{ width: '40%' }} />
    </SkeletonCard>
  );
};

export default MetricCardSkeleton;
